import DoubleArrowIcon from '@mui/icons-material/DoubleArrowRounded';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { Avatar, Box, Typography } from '@mui/material';
import TimeAgo from 'javascript-time-ago';
import { useTranslation } from 'react-i18next';
import { NotificationFieldsFragment } from '../../../../../../../../generated/core-api/graphql-react-query';
import RoleTag from '../RoleTag';

export default function UserRoleChangedNotificationBox(props: { notification: NotificationFieldsFragment }) {
  const { notification } = props;
  const { t, i18n } = useTranslation('widgets');
  const timeAgo = new TimeAgo(i18n.language);

  const oldRole = parseInt(notification.event.oldValue ?? '0', 10);
  const newRole = parseInt(notification.event.newValue ?? '0', 10);

  return (
    <>
      <Avatar className="user">
        <SupervisorAccountIcon />
      </Avatar>
      <Box className="message userRoleChanged">
        <Typography variant="subtitle1">
          <strong>{notification.event.author?.displayName}</strong>
          {t('notifications.user.role-changed')}
        </Typography>
        <Typography variant="body1" component="div">
          <RoleTag role={oldRole} />
          <DoubleArrowIcon />
          <RoleTag role={newRole} />
        </Typography>
        <Typography variant="subtitle2">
          {timeAgo.format(new Date(notification.date))}
        </Typography>
      </Box>
    </>
  );
}
